import { useWidgetData } from '../useWidgetData'

import { HomeOverview } from '../../../types/home/home'

export const useHomeWidget = () => useWidgetData<HomeOverview>('home')
